import { apiJson, apiRaw } from '@/lib/http';

interface ApiResponse<T> {
  success?: boolean;
  message?: string;
  data: T;
}

type GenerateDemoResponse = unknown; // backend returns GenericDataset; shape not needed for triggering

const unwrap = <T>(res: ApiResponse<T> | T): T => (res as ApiResponse<T>)?.data ?? (res as T);

export const demoService = {
  async generateDemoData(params: { settingsId: string, companyName?: string; demodataDescription?: string }) {
    return apiJson<ApiResponse<GenerateDemoResponse> | GenerateDemoResponse>(`/Demo/generateDemoData`, {
      method: 'POST',
      body: JSON.stringify({ settingsId: params.settingsId, companyName: params.companyName, demodataDescription: params.demodataDescription })
    }).then(unwrap);
  },
  async getFakeData(settingsId: string): Promise<string> {
    const res = await apiJson<ApiResponse<{ fakeData: string }> | { fakeData: string }>(`/Demo/fakeData/${settingsId}`);
    const data = (res as ApiResponse<{ fakeData: string }>)?.data ?? (res as { fakeData: string });
    return data?.fakeData ?? '';
  },
  async updateFakeData(settingsId: string, fakeData: string) {
    return apiJson<ApiResponse<{ saved: boolean }> | { saved: boolean }>(`/Demo/updateFakeData`, {
      method: 'POST',
      body: JSON.stringify({ settingsId: settingsId, fakeData: fakeData }),
    });
  },
  async uploadFakeBackground(settingsId: string, file: File) {
    const form = new FormData();
    form.append('file', file);
    const res = await apiRaw(`/Demo/uploadFakeBackground/${settingsId}`, {
      method: 'POST',
      body: form,
    });
    return res.json();
  }
};


